import Vue from 'vue';
import Router from 'vue-router';

import companiesRoutes from './companiesRoutes';
import contractRouters from './contractRoutes';
import subContractRoutes from './subContractRoutes';
import contractDetailsRoutes from './contractDetailsRoutes';

// Importa otros archivos de rutas aquí

Vue.use(Router);

const routes = [
    ...companiesRoutes,
    ...contractRouters,
    ...subContractRoutes,
    ...contractDetailsRoutes
    // otras rutas
]; 

const router = new Router({
    mode: 'history',
    routes
});

export default router;
